// extracted by mini-css-extract-plugin
export default {"resultItem":"ResultItem_resultItem__KgCan","leftBorder":"ResultItem_leftBorder__2spVw","primaryText":"ResultItem_primaryText__-vBs9"};